import script from "./MarketingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketingPage.vue?vue&type=script&setup=true&lang=js"

import "./MarketingPage.vue?vue&type=style&index=0&id=274b5fb7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-274b5fb7"]])

export default __exports__